import vuetify from '@/main';
import Dashboard from '@/modules/dashboard/Dashboard.vue';
angular.module('leanlaw').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('dashboard', {
    url: '/dashboard/{tag}',
    params: {
      tag: {
        value: null,
        squash: true
      }
    },
    ...vuetify(Dashboard)
  });
}]);